import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import HashLoader from "react-spinners/HashLoader";
import { colors, Container, Dialog, Modal } from "@material-ui/core";
import LoadingPage from "../../../../services/LoadingPage";
import ItemsMove from "./ItemsMove";
const defaultAutos = {
  Safes: [],
};

export default function ItemsMoveCon() {
  const tb2 = {
    Safe: true,
    SafeEmp:true,
    EmpItems: true,
    stor: sto,
    parms: { 
        branch: sto.branchi  ,
        iempid: sto.empi,
     },

  };

  const { object: AutoOptionsB, fetching: fetchAllS } = useFetchObjectByPost(
    uri + "GetD",
    tb2,
  );
  const tb = {
    wait: true,
    // Safes: true,
    // Currencies: true,
    Branches: true,
    costcenters: true,
    stor: sto,
    parms: {
    // safe:-1,
    // item:-1,
    iempid: sto.empi,
    branch:sto.branchi
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb,
  );

  if (
    fetchAll ||
    fetchAllS||!AutoOptionsB.Safes|| !AutoOptionsB.items
  )
    return <LoadingPage />;

  return (
    <ItemsMove
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        AutoOptionsB
      }}
    />
  );
}
